export default __webpack_public_path__ + "static/media/icon-coin-dydx.bf085f78.svg";